<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    startAtEnd: {
      type: Boolean,
    },
  },
  data() {
    return {
      currentIndex: 0,
    }
  },
  computed: {
    canClickLeft() {
      return this.currentIndex !== 0
    },

    canClickRight() {
      return this.currentIndex < this.items.length - 1
    },

    currentScrollerItem() {
      return this.items[this.currentIndex]
    },
  },
  created() {
    if (this.startAtEnd) {
      this.currentIndex = this.items.length - 1
    }
    this.$emit('updateScrollerItem', this.currentScrollerItem)
  },
  methods: {
    scrollBack() {
      if (this.currentIndex <= 0) {
        return
      }

      this.currentIndex--
      this.$emit('updateScrollerItem', this.currentScrollerItem)
    },
    scrollForward() {
      if (this.currentIndex >= this.items.length - 1) {
        return
      }

      this.currentIndex++
      this.$emit('updateScrollerItem', this.currentScrollerItem)
    },
  },
}
</script>

<template>
  <div class="d-flex align-items-center">
    <div
      data-scroller-selector-back
      :class="{ [$style.scrollerArrow]: true, [$style.disabled]: !canClickLeft }"
      @click="scrollBack" />
    <slot :currentScrollerItem="currentScrollerItem" />
    <div
      data-scroller-selector-forward
      :class="{ [$style.scrollerArrow]: true, [$style.disabled]: !canClickRight, [$style.right]: true }"
      @click="scrollForward" />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.disabled {
  cursor: default !important;
  opacity: 0;
}

.scrollerArrow {
  width: 40px;
  height: 40px;
  cursor: pointer;
  background: url(~@assets/icons/ArrowGray.svg) no-repeat center;
  border: 1px solid $light-gray;
  border-radius: 50%;

  &.right {
    transform: rotate(180deg);
  }
}
</style>
